export const MuiFormLabel = () => ({
  styleOverrides: {
    root: {
      fontSize: 16,
      lineHeight: 1.125,
      top: '3px !important'
    }
  }
})
